import styled from "@emotion/styled"
import { Container } from "@mui/material"

export const TextContainer = styled(Container)`
    &&& {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 5vw;
    padding-right: 5vw;
    padding-top: 2vh;
    padding-bottom: 25vh;
    }
`

export const HowItsMadeHeader = styled.span`
    &&& {
        font-weight: bolder;
        font-size: 50pt;
    }
`

export const HowItsMadeBody = styled.div`
    &&& {
        padding-top: 2vh;
        font-size: 18pt;
        opacity: 1;
        animation: fadeIn linear 500ms;
    }

    @keyframes fadeIn {
        0% {opacity:0;}
        100% {opacity:1;}
    }
`

export const StyledLink = styled.a`
    &&& {
       text-decoration: none;
       font-weight: bold;
       color: black;  
    }
    &&&:hover {
        text-decoration: underline;
    }
`

export const CustomIcon = styled.img`
    &&& {
        position: relative;
        display: inline-block;
        align-items: center;
        justify-content: center;
        padding-right: 2px;
        top: 3px;
    }
`